<script>
  import CeTa from "./CeTa.svelte";
  import { dict_to_sum, dict_to_sum_2d, dict_to_sum_2d_each_last_month, get_last_month_value } from "./UtilsBalkenProgress.svelte";

  import { find_help_text_if_exists } from "./Utils.svelte";

  export let laender_dict;
  export let laender_dict_targets;
  export let active_boli_end_of_timeframe;
  export let adressable_market_size_charts_dict;
  export let acq_cost_dict;
  export let cost_per_new_customer;
  export let cost_per_new_cow;
  export let active_boluses_per_customer;

  export let balken_leads_opps_cust_boli;
  export let new_leads_target;
  export let open_leads_per_country;
  export let open_opps_per_country;
  export let customer_churn;
  export let table_sold_boli_dict_per_country;

  export let lost_boli_per_country;
  export let herd_churn_per_country;
  export let active_animals_table_values;
  export let sold_boli_target;

  export let helptexts;
  export let in_show_helptext_id;

  export let marketing_end_date;
  export let marketing_start_date;
  export let is_ytd = false;

  function day_of_year(date) {
    var now = date;
    var start = new Date(now.getFullYear(), 0, 0);
    var diff = now - start;
    var oneDay = 1000 * 60 * 60 * 24;
    var day = Math.floor(diff / oneDay);

    return day;
  }

  function timeframe_is_like_ytd(start, end) {
    var now = new Date();

    if (
      start.getFullYear() == now.getFullYear() &&
      start.getMonth() == 0 &&
      end.getFullYear() == now.getFullYear() &&
      end.getMonth() == now.getMonth()
    ) {
      return true;
    }
    return false;
  }
</script>

<tr style="height:100px;">
  <td>&nbsp;</td>
</tr>

<tr class="table_title_row">
  <td class="table_first_col table_title" style="">Addressable market information</td>
  {#each laender_dict as land_eintrag, index}
    {#if land_eintrag["checked"]}
      <td style=" text-align:center; font-size:0.9rem!important; font-weight:300!important;"
        ><div
          style="margin-left: 3px!important; margin-right: 3px!important; color:#FFFFFF; background-color: #87A896; margin-bottom:1px!important;"
        >
          {land_eintrag["short"]}
        </div></td
      >
    {/if}
  {/each}
  <td style=" text-align:center; font-size:0.9rem!important; font-weight:300!important;"
    ><div
      style="margin-left: 3px!important; margin-right: 3px!important; color:#FFFFFF; background-color: #87A896; margin-bottom:1px!important;"
    >
      Total
    </div></td
  >
</tr>

<tr>
  <td class="table_first_col"><div class="grau_ausgefuellt">Addressable market size (#cows)</div></td>
  {#each laender_dict as land_eintrag, index}
    {#if land_eintrag["checked"]}
      <CeTa value={laender_dict_targets[land_eintrag["short"]]["AMS"]} extra_classes={"grau_ausgefuellt"} />
    {/if}
  {/each}
  <CeTa value={laender_dict_targets["Total"]["AMS"]} extra_classes={"grau_ausgefuellt bold"} />
</tr>

<tr>
  <td class="table_first_col"><div class="grau_ausgefuellt">Addressable market size (#farms)</div></td>
  {#each laender_dict as land_eintrag, index}
    {#if land_eintrag["checked"]}
      <CeTa value={laender_dict_targets[land_eintrag["short"]]["AMS_Farms"]} extra_classes={"grau_ausgefuellt"} />
    {/if}
  {/each}
  <CeTa value={laender_dict_targets["Total"]["AMS_Farms"]} extra_classes={"grau_ausgefuellt bold"} />
</tr>

<tr>
  <td class="table_first_col"><div class="gruen_ausgefuellt">Active boluses (end of timeframe)</div></td>
  {#each laender_dict as land_eintrag, index}
    {#if land_eintrag["checked"] && active_boli_end_of_timeframe}
      <CeTa value={get_last_month_value(active_boli_end_of_timeframe[land_eintrag["long"]])} extra_classes={"gruen_ausgefuellt"} />
    {/if}
  {/each}
  <CeTa value={dict_to_sum_2d_each_last_month(active_boli_end_of_timeframe)} extra_classes={"gruen_ausgefuellt bold"} />
</tr>

<tr>
  <td class="table_first_col">Market share (end of timeframe)</td>
  {#each laender_dict as land_eintrag, index}
    {#if land_eintrag["checked"]}
      <CeTa value={adressable_market_size_charts_dict[land_eintrag["short"]]["AMS_percentage"]} append={"%"} />
    {/if}
  {/each}
  <CeTa value={adressable_market_size_charts_dict["Total"]["AMS_percentage"]} append={"%"} extra_classes={"bold"} />
</tr>

<tr>
  <td class="table_first_col blue_text">Market share target (end of year of timeframe)</td>
  {#each laender_dict as land_eintrag, index}
    {#if land_eintrag["checked"]}
      <CeTa value={adressable_market_size_charts_dict[land_eintrag["short"]]["AMT_percentage"]} append={"%"} extra_classes={"blue_text"} />
    {/if}
  {/each}
  <CeTa value={adressable_market_size_charts_dict["Total"]["AMT_percentage"]} append={"%"} extra_classes={"bold blue_text"} />
</tr>

<tr>
  <td class="table_first_col"
    >Cost per lead (in timeframe) <div class="hoverclass">
      <b>ⓘ</b>
      <div class="info-box-auf-hoehe">
        {#if find_help_text_if_exists(helptexts, "management_reporting_data_table_1")}
          {@html find_help_text_if_exists(helptexts, "management_reporting_data_table_1")}
        {:else}
          <p>
            <strong>Cost per lead</strong> &hellip; indicates how much spending for marketing and sales has been necessary to generate one new
            lead.
          </p>
          <p>
            The calculation is done by dividing the total cost of marketing and sales (company-wide) in the reporting period by the total
            number of new leads in the reporting period.
          </p>
          <p>
            The total marketing and sales costs are calculated on a daily basis based on the budgeted annual costs pro rata for the
            reporting period.
          </p>
        {/if}
        {#if in_show_helptext_id}
          <div style="font-size: 7px">id: management_reporting_data_table_1</div>
          <div style="font-size: 7px">
            [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
          </div>
        {/if}
      </div>
    </div></td
  >
  {#each laender_dict as land_eintrag, index}
    {#if land_eintrag["checked"]}
      <CeTa value={""} append={""} />
    {/if}
  {/each}

  {#if is_ytd || timeframe_is_like_ytd(marketing_start_date, marketing_end_date)}
    <CeTa
      value={(acq_cost_dict["Total"] * day_of_year(marketing_end_date)) / 365 / balken_leads_opps_cust_boli["Total"][0]}
      append={"€"}
      extra_classes={"bold"}
    />
  {:else}
    <CeTa
      value={(acq_cost_dict["Total"] * (day_of_year(marketing_end_date) - day_of_year(marketing_start_date))) /
        365 /
        balken_leads_opps_cust_boli["Total"][0]}
      append={"€"}
      extra_classes={"bold"}
    />
  {/if}
</tr>

<tr>
  <td class="table_first_col"
    >Cost per new customer (in timeframe)
    <div class="hoverclass">
      <b>ⓘ</b>
      <div class="info-box-auf-hoehe">
        {#if find_help_text_if_exists(helptexts, "management_reporting_data_table_2")}
          {@html find_help_text_if_exists(helptexts, "management_reporting_data_table_2")}
        {:else}
          <p>
            <strong>Cost per new customer</strong> &hellip; indicates how much spending for marketing and sales has been necessary to generate
            one new customer.
          </p>
          <p>
            The calculation is done by dividing the total cost of marketing and sales (company-wide) in the reporting period by the total
            number of new customers in the reporting period. The total marketing and sales costs are calculated on a daily basis based on
            the budgeted annual costs pro rata for the reporting period.
          </p>
        {/if}
        {#if in_show_helptext_id}
          <div style="font-size: 7px">id: management_reporting_data_table_2</div>
          <div style="font-size: 7px">
            [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
          </div>
        {/if}
      </div>
    </div></td
  >

  {#each laender_dict as land_eintrag, index}
    {#if land_eintrag["checked"]}
      <CeTa value={""} append={""} />
    {/if}
  {/each}
  <CeTa value={cost_per_new_customer} append={"€"} extra_classes={"bold"} />
</tr>

<tr>
  <td class="table_first_col"
    >Cost per new cow (in timeframe) <div class="hoverclass">
      <b>ⓘ</b>
      <div class="info-box-auf-hoehe">
        {#if find_help_text_if_exists(helptexts, "management_reporting_data_table_3")}
          {@html find_help_text_if_exists(helptexts, "management_reporting_data_table_3")}
        {:else}
          <p>
            <strong>Cost per new cow</strong> &hellip; indicates how much spending for marketing and sales has been necessary to generate one
            new cow under monitoring.
          </p>
          <p>
            The calculation is done by dividing the total costs for marketing and sales (company-wide) in the reporting period by the total
            number new boluses of new customers in the reporting period.
          </p>
          <p>
            The total marketing and sales costs are calculated on a daily basis based on the budgeted annual costs pro rata for the
            reporting period.
          </p>
        {/if}
        {#if in_show_helptext_id}
          <div style="font-size: 7px">id: management_reporting_data_table_3</div>
          <div style="font-size: 7px">
            [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
          </div>
        {/if}
      </div>
    </div></td
  >
  {#each laender_dict as land_eintrag, index}
    {#if land_eintrag["checked"]}
      <CeTa value={""} append={""} />
    {/if}
  {/each}

  <CeTa value={cost_per_new_cow} append={"€"} extra_classes={"bold"} />
</tr>

<tr>
  <td class="table_first_col"
    >Active boluses per customer (end of timeframe)
    <div class="hoverclass">
      <b>ⓘ</b>
      <div class="info-box-auf-hoehe">
        {#if find_help_text_if_exists(helptexts, "management_reporting_data_table_4")}
          {@html find_help_text_if_exists(helptexts, "management_reporting_data_table_4")}
        {:else}
          <p>
            <strong>Active boluses per customer</strong> &hellip; indicates the average number of cows under monitoring per customer per country
            at the end of the selected reporting timeframe.
          </p>
          <p>
            The calculation is done by dividing the number of active boluses by the number of active customers (both at the end of the
            reporting timeframe).
          </p>
        {/if}
        {#if in_show_helptext_id}
          <div style="font-size: 7px">id: management_reporting_data_table_4</div>
          <div style="font-size: 7px">
            [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
          </div>
        {/if}
      </div>
    </div></td
  >

  {#each laender_dict as land_eintrag, index}
    {#if land_eintrag["checked"]}
      {#if land_eintrag["long"] in active_boluses_per_customer}
        <CeTa value={active_boluses_per_customer[land_eintrag["long"]]} append={""} />
      {/if}
    {/if}
  {/each}

  {#if "Total" in active_boluses_per_customer}
    <CeTa value={active_boluses_per_customer["Total"]} extra_classes={"bold"} />
  {/if}
</tr>

<tr class="abstand_zwischen_subtabellen" />

<tr class="table_title_row">
  <td class="table_title table_first_col">Leads</td>
</tr>

<tr>
  <td class="table_first_col"
    >&nbsp;&nbsp;New Leads <div class="hoverclass">
      <b>ⓘ</b>
      <div class="info-box-auf-hoehe">
        {#if find_help_text_if_exists(helptexts, "management_reporting_data_table_5")}
          {@html find_help_text_if_exists(helptexts, "management_reporting_data_table_5")}
        {:else}
          <p>
            <strong>New leads</strong>&hellip; Please note that leads from the sales source category "data import" are only counted as
            &rdquo;new lead" if an opportunity is created based on the lead. In this case, the lead creation date is the same as the
            opportunity creation date.
          </p>
        {/if}
        {#if in_show_helptext_id}
          <div style="font-size: 7px">id: management_reporting_data_table_5</div>
          <div style="font-size: 7px">
            [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
          </div>
        {/if}
      </div>
    </div></td
  >
  {#each laender_dict as land_eintrag, index}
    {#if land_eintrag["checked"]}
      <CeTa value={balken_leads_opps_cust_boli[land_eintrag["long"]][0]} />
    {/if}
  {/each}
  <CeTa value={balken_leads_opps_cust_boli["Total"][0]} extra_classes={"bold"} />
</tr>

<tr>
  <td class="table_first_col blue_text">&nbsp;&nbsp;New leads target</td>
  {#each laender_dict as land_eintrag, index}
    {#if land_eintrag["checked"]}
      <CeTa value={""} extra_classes={"blue_text"} />
    {/if}
  {/each}
  <CeTa value={new_leads_target} append={""} extra_classes={"bold blue_text"} />
</tr>

<tr>
  <td class="table_first_col grey_text">&nbsp;&nbsp;Open leads (end of timeframe)</td>
  {#each laender_dict as land_eintrag, index}
    {#if land_eintrag["checked"]}
      <CeTa value={open_leads_per_country[land_eintrag["long"]]} extra_classes={"grey_text"} />
    {/if}
  {/each}
  <CeTa value={open_leads_per_country["Total"]} extra_classes={"bold"} />
</tr>

<tr class="abstand_zwischen_subtabellen" />

<tr class="table_title_row">
  <td class="table_title table_first_col">OPPs & CUST</td>
</tr>

<tr>
  <td class="table_first_col">&nbsp;&nbsp;New OPP</td>
  {#each laender_dict as land_eintrag, index}
    {#if land_eintrag["checked"]}
      <CeTa value={balken_leads_opps_cust_boli[land_eintrag["long"]][1]} />
    {/if}
  {/each}
  <CeTa value={balken_leads_opps_cust_boli["Total"][1]} extra_classes={"bold"} />
</tr>

<tr>
  <td class="table_first_col grey_text">&nbsp;&nbsp;Open OPP (end of timeframe)</td>
  {#each laender_dict as land_eintrag, index}
    {#if land_eintrag["checked"]}
      <CeTa value={open_opps_per_country[land_eintrag["long"]]} extra_classes={"grey_text"} />
    {/if}
  {/each}
  <CeTa value={open_opps_per_country["Total"]} extra_classes={"bold"} />
</tr>

<tr>
  <td class="table_first_col">&nbsp;&nbsp;New CUST</td>
  {#each laender_dict as land_eintrag, index}
    {#if land_eintrag["checked"]}
      <CeTa value={balken_leads_opps_cust_boli[land_eintrag["long"]][2]} />
    {/if}
  {/each}
  <CeTa value={balken_leads_opps_cust_boli["Total"][2]} extra_classes={"bold"} />
</tr>

<tr>
  <td class="table_first_col orange_text">&nbsp;&nbsp;Customer churn</td>
  {#each laender_dict as land_eintrag, index}
    {#if land_eintrag["checked"]}
      <CeTa pre_value={"-"} value={customer_churn[land_eintrag["long"]]} extra_classes={"orange_text"} />
    {/if}
  {/each}
  <CeTa pre_value={"-"} value={customer_churn["Total"]} extra_classes={"orange_text bold"} />
</tr>

<tr class="abstand_zwischen_subtabellen" />

<tr class="table_title_row">
  <td class="table_title table_first_col">Sold BOLUSES</td>
</tr>

<tr>
  <td class="table_first_col">&nbsp;&nbsp;Sold BOLUSES</td>
  {#each laender_dict as land_eintrag, index}
    {#if land_eintrag["checked"]}
      <CeTa value={table_sold_boli_dict_per_country[land_eintrag["long"]]} />
    {/if}
  {/each}
  <CeTa value={table_sold_boli_dict_per_country["Total"]} extra_classes={"bold"} />
</tr>

<tr>
  <td class="table_first_col blue_text">&nbsp;&nbsp;Sold BOLUSES target</td>
  {#each laender_dict as land_eintrag, index}
    {#if land_eintrag["checked"]}
      <CeTa value={sold_boli_target[land_eintrag["short"]]} extra_classes={"blue_text"} />
    {/if}
  {/each}
  <CeTa value={dict_to_sum(sold_boli_target)} extra_classes={"bold blue_text"} />
</tr>

<tr class="abstand_zwischen_subtabellen" />

<tr class="table_title_row">
  <td class="table_title table_first_col">New Boluses & Boluses Churn</td>
</tr>

<tr>
  <td class="table_first_col"
    >&nbsp;&nbsp;New boluses (new customers) <div class="hoverclass">
      <b>ⓘ</b>
      <div class="info-box-auf-hoehe">
        {#if find_help_text_if_exists(helptexts, "management_reporting_data_table_6")}
          {@html find_help_text_if_exists(helptexts, "management_reporting_data_table_6")}
        {:else}
          <p>
            <strong>New boluses (new customers)</strong> &hellip; Total number of new boluses from new customers. A &ldquo;new bolus&rdquo; is
            a bolus that has been activated during the reporting timeframe. Such bolus activation is considered as &ldquo;new bolus from a new
            customer&rdquo; if it is activated within 6 months of the month in which the customer signed up for the contract.
          </p>
          <p>
            Example: A customer&acute;s contract signing date is in January 2023. All boluses activated in the period 01/2023 &ndash;
            07/2023 (=month of contract signing + 6 months) are considered as &ldquo;<strong>new bolus from new customers</strong>&rdquo;.
            From 08/2023 onwards, new boluses from this customer will be shown as "Increase".
          </p>
        {/if}
        {#if in_show_helptext_id}
          <div style="font-size: 7px">id: management_reporting_data_table_6</div>
          <div style="font-size: 7px">
            [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
          </div>
        {/if}
      </div>
    </div></td
  >
  {#each laender_dict as land_eintrag, index}
    {#if land_eintrag["checked"]}
      <CeTa value={dict_to_sum(active_animals_table_values["New boli (new customers)"][land_eintrag["long"]])} />
    {/if}
  {/each}
  <CeTa value={dict_to_sum_2d(active_animals_table_values["New boli (new customers)"])} extra_classes={"bold"} />
</tr>

<tr>
  <td class="table_first_col"
    >&nbsp;&nbsp;Increase <div class="hoverclass">
      <b>ⓘ</b>
      <div class="info-box-auf-hoehe">
        {#if find_help_text_if_exists(helptexts, "management_reporting_data_table_7")}
          {@html find_help_text_if_exists(helptexts, "management_reporting_data_table_7")}
        {:else}
          <p>
            <strong>Increase</strong> &hellip; Total number of boluses activated during the reporting timeframe excluding &ldquo;New boluses
            (new customers)&rdquo;.
          </p>
          <p>This number is an indicator for the number of bolus activations due to bolus replacement (remounting).</p>
        {/if}
        {#if in_show_helptext_id}
          <div style="font-size: 7px">id: management_reporting_data_table_7</div>
          <div style="font-size: 7px">
            [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
          </div>
        {/if}
      </div>
    </div></td
  >
  {#each laender_dict as land_eintrag, index}
    {#if land_eintrag["checked"]}
      <CeTa value={dict_to_sum(active_animals_table_values["Increase"][land_eintrag["long"]])} />
    {/if}
  {/each}
  <CeTa value={dict_to_sum_2d(active_animals_table_values["Increase"])} extra_classes={"bold"} />
</tr>

<tr>
  <td class="table_first_col"
    >&nbsp;&nbsp;Decrease <div class="hoverclass">
      <b>ⓘ</b>
      <div class="info-box-auf-hoehe">
        {#if find_help_text_if_exists(helptexts, "management_reporting_data_table_8")}
          {@html find_help_text_if_exists(helptexts, "management_reporting_data_table_8")}
        {:else}
          <p>
            <strong>Decrease</strong> &hellip; Total number of boluses deactivated during the reporting timeframe excluding &ldquo;Bolus churn&rdquo;.
          </p>
          <p>This number is an indicator for the number of bolus deactivations due to bolus replacement (remounting).</p>
        {/if}
        {#if in_show_helptext_id}
          <div style="font-size: 7px">id: management_reporting_data_table_8</div>
          <div style="font-size: 7px">
            [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
          </div>
        {/if}
      </div>
    </div></td
  >
  {#each laender_dict as land_eintrag, index}
    {#if land_eintrag["checked"]}
      <CeTa pre_value={"-"} value={dict_to_sum(active_animals_table_values["Decrease"][land_eintrag["long"]])} />
    {/if}
  {/each}
  <CeTa pre_value={"-"} value={dict_to_sum_2d(active_animals_table_values["Decrease"])} extra_classes={"bold"} />
</tr>

<tr>
  <td class="table_first_col orange_text"
    >&nbsp;&nbsp;Bolus churn <div class="hoverclass">
      <b>ⓘ</b>
      <div class="info-box-auf-hoehe">
        {#if find_help_text_if_exists(helptexts, "management_reporting_data_table_9")}
          {@html find_help_text_if_exists(helptexts, "management_reporting_data_table_9")}
        {:else}
          <p>
            <strong>Bolus churn</strong> &hellip; Total number of active boluses from customers who cancelled their subscription during the reporting
            timeframe, immediately before the customer cancelled the contract.
          </p>
          <p>Bolus churn therefore shows the active boluses that have been deactivated due to the cancellation of the subscription.</p>
        {/if}
        {#if in_show_helptext_id}
          <div style="font-size: 7px">id: management_reporting_data_table_9</div>
          <div style="font-size: 7px">
            [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
          </div>
        {/if}
      </div>
    </div></td
  >
  {#each laender_dict as land_eintrag, index}
    {#if land_eintrag["checked"]}
      <CeTa pre_value={"-"} value={lost_boli_per_country[land_eintrag["long"]]} extra_classes={"orange_text"} />
    {/if}
  {/each}
  <CeTa pre_value={"-"} value={lost_boli_per_country["Total"]} extra_classes={"orange_text bold"} />
</tr>

<tr>
  <td class="table_first_col orange_text"
    >&nbsp;&nbsp;Herd churn <div class="hoverclass">
      <b>ⓘ</b>
      <div class="info-box-auf-hoehe">
        {#if find_help_text_if_exists(helptexts, "management_reporting_data_table_10")}
          {@html find_help_text_if_exists(helptexts, "management_reporting_data_table_10")}
        {:else}
          <p>
            <strong>Herd churn</strong> &hellip; Total of &ldquo;Max Installations&rdquo; of churn customers (customers who cancelled their subscription
            during the reporting timeframe).
          </p>
          <p>This number is an indicator of the total number of cows under monitoring lost due to contract termination.</p>
        {/if}
        {#if in_show_helptext_id}
          <div style="font-size: 7px">id: management_reporting_data_table_10</div>
          <div style="font-size: 7px">
            [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
          </div>
        {/if}
      </div>
    </div></td
  >
  {#each laender_dict as land_eintrag, index}
    {#if land_eintrag["checked"]}
      <CeTa pre_value={"-"} value={herd_churn_per_country[land_eintrag["long"]]} extra_classes={"orange_text"} />
    {/if}
  {/each}
  <CeTa pre_value={"-"} value={herd_churn_per_country["Total"]} extra_classes={"orange_text bold"} />
</tr>

<style>
  td {
    font-size: 14px !important;
  }

  .table_first_col {
    margin-left: 20px;
    text-align: left;
    padding-left: 10px;
  }

  .table_title {
    font-weight: bold;
  }

  .table_title_row {
    border-bottom: 0.5px solid #d7e2dc;
  }

  .blue_text {
    color: #4299b0;
  }

  .grey_text {
    color: grey;
  }

  .orange_text {
    color: orange;
  }

  .abstand_zwischen_subtabellen {
    height: 25px;
  }

  .gruen_ausgefuellt {
    margin-left: 3px;
    margin-right: 3px;
    background-color: #afcb08;
  }

  .grau_ausgefuellt {
    margin-left: 3px;
    margin-right: 3px;
    background-color: #d7e2dc;
  }

  .info-box-auf-hoehe {
    background: #ffffff;
    border: 0.25pt solid #d9d9d9;
    color: #000000;
    font-size: 12px;
    height: auto;
    width: auto;

    /*line-height: 10px;*/
    position: absolute;
    text-align: left;
    margin-left: 20px;
    /*text-transform: uppercase;*/
    top: inherit;
    left: inherit;
    display: none;
    padding: 20px;
    z-index: 10;
    padding-bottom: 0px;
    padding-top: 15px;
  }

  .info-box {
    background: #ffffff;
    border: 0.25pt solid #d9d9d9;
    color: #000000;
    font-size: 12px;
    height: auto;
    width: 600;

    /*line-height: 10px;*/
    position: absolute;
    text-align: left;
    /*text-transform: uppercase;*/
    top: 30px;
    left: 30px;
    display: none;
    padding: 20px;
    z-index: 10;
    padding-bottom: 0px;
    padding-top: 15px;
  }

  .info-box:hover .info-box {
    display: block;
  }

  .info-circle {
    display: flex;
    justify-content: center;
    align-items: center;
    /*background-color: #eef3f0;*/
    border: 1px solid #999999;
    height: 25px;
    border-radius: 50%;
    width: 25px;
    text-align: center;
  }

  .info-circle:hover .info-box {
    display: block;
  }

  .info-circle:hover .info-i {
    display: none;
  }

  .hoverclass {
    display: inline-block;
  }

  .hoverclass:hover .info-box {
    display: block;
  }

  .hoverclass:hover .info-i {
    display: none;
  }

  .info-box-auf-hoehe:hover .info-box-auf-hoehe {
    display: block;
  }

  .info-circle:hover .info-box-auf-hoehe {
    display: block;
  }

  .hoverclass:hover .info-box-auf-hoehe {
    display: block;
  }
</style>
